import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {JsonEditorComponent, JsonEditorOptions} from "ang-jsoneditor";
import {environment} from "../../../environments/environment";
import {HttpHeaders} from "@angular/common/http";
import {ConnecttocrudService} from "../../connecttocrud.service";


@Component
({
    selector: 'resource-json-editor',
    templateUrl: './resource-json-editor.component.html'
})
export class ResourceJsonEditorComponent implements OnInit{
    finalData: any;
    postHttpOptions: any;
    postRequest: any;
    @ViewChild(JsonEditorComponent, { static: true }) editor: JsonEditorComponent;
    options = new JsonEditorOptions();
    constructor(private _service: ConnecttocrudService){
        this.options.mode = 'code';
        this.options.modes = ['code', 'text', 'tree', 'view'];
        this.options.schema = '';
        this.options.statusBar = false;
        this.options.onChange = () => console.log(/*this.editor.get()*/);
    }
    @Input() data: any;
    @Input() getData: any;
    @Output() dataChange = new EventEmitter();
    @Output() getDataChange = new EventEmitter();
    @Input() dataResponse: any;
    @Output() dataResponseChange = new EventEmitter();
    ngOnInit(): void {

    }
    emit() {
        const httpOptions1 = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': this.getData.pkey,
                'Access-Control-Allow-Origin': '*'
            })
        };

        this.postHttpOptions = httpOptions1;
        this.postRequest = environment.apihost + '/' + this.getData.url;
        const data = this.editor.get();

        this._service.postItemForUrl(this.getData.url, this.postHttpOptions, data).subscribe(items => {
            this.dataResponseChange.emit(items);
        });
    }
}